export default __webpack_public_path__ + "static/media/back-small-gray.9f6e45b7.svg";